//util_function.ts
import { CheckBoxList } from "../interface/DataI";
import CryptoJS from 'crypto-js';
import {
    RECIPIENT_KEY, V2_RECIPIENT_KEY, DOMAINE_CHECKBOX_KEY, JOB_CHECKBOX_KEY,
    TECHNOLOGY_KEY, INCLUDE_LOCALISATION_KEY, EXCLUDE_LOCALISATION_KEY, DEST_SAVING_STATE,
    SENDER_KEY, V2_SENDER_KEY, SENDER_SAVING_STATE, SERVICE_VALUE_KEY,
    V2_MAIL_KEY, MAIL_CHECKBOX_KEY, MAIL_LANGUAGE_KEY, MAIL_TITLE_CHECKBOX_KEY,
    MAIL_ACC_CHECKBOX_KEY, ACCROCHE_KEY, INCITATION_KEY, TITRE_MAIL_KEY, PROMPT2LLM_KEY,
    FOLLOW_UP_DATA, FOLLOWUP_SAVING_STATE, DOC_ID_KEY, RAIS_COMM_KEY,
    CAMPAGN_LOAD_STATE, CAMPAIGN_RUNING_KEY, QA_TIPS4_USER_KEY,
    ESTIMATED_PROSPECT_COUNT_KEY, CAMPAIGN_EMAIL_COUNT_KEY
} from "../constants/StoreKey";

export const CAMPAIGN_SCOPED_KEYS: string[] = [
    RECIPIENT_KEY, V2_RECIPIENT_KEY, DOMAINE_CHECKBOX_KEY, JOB_CHECKBOX_KEY,
    TECHNOLOGY_KEY, INCLUDE_LOCALISATION_KEY, EXCLUDE_LOCALISATION_KEY, DEST_SAVING_STATE,
    SENDER_KEY, V2_SENDER_KEY, SENDER_SAVING_STATE, SERVICE_VALUE_KEY, QA_TIPS4_USER_KEY,
    V2_MAIL_KEY, MAIL_CHECKBOX_KEY, MAIL_LANGUAGE_KEY, MAIL_TITLE_CHECKBOX_KEY,
    MAIL_ACC_CHECKBOX_KEY, ACCROCHE_KEY, INCITATION_KEY, TITRE_MAIL_KEY, PROMPT2LLM_KEY,
    "TEMPLATE_A_TITLE_KEY", "TEMPLATE_A_BODY_KEY", "TEMPLATE_A_SIGNATURE_KEY",
    "TEMPLATE_B_TITLE_KEY", "TEMPLATE_B_BODY_KEY", "TEMPLATE_B_SIGNATURE_KEY",
    "TEMPLATE_C_TITLE_KEY", "TEMPLATE_C_BODY_KEY", "TEMPLATE_C_SIGNATURE_KEY",
    "TEMPLATE_SIGNATURE_KEY",
    FOLLOW_UP_DATA, FOLLOWUP_SAVING_STATE,
    DOC_ID_KEY, RAIS_COMM_KEY, CAMPAGN_LOAD_STATE, CAMPAIGN_RUNING_KEY,
    ESTIMATED_PROSPECT_COUNT_KEY, CAMPAIGN_EMAIL_COUNT_KEY,
];

export const CAMPAIGN_SNAPSHOT_PREFIX = "CAMPAIGN_SNAPSHOT__";

export const clearCampaignScopedData = () => {
    CAMPAIGN_SCOPED_KEYS.forEach(key => localStorage.removeItem(key));
};

const saveCampaignSnapshotForBlock = (blockTitle: string) => {
    const snapshot: Record<string, string | null> = {};
    CAMPAIGN_SCOPED_KEYS.forEach(key => {
        snapshot[key] = localStorage.getItem(key);
    });
    localStorage.setItem(CAMPAIGN_SNAPSHOT_PREFIX + blockTitle, JSON.stringify(snapshot));
};

const restoreCampaignSnapshotForBlock = (blockTitle: string): boolean => {
    const raw = localStorage.getItem(CAMPAIGN_SNAPSHOT_PREFIX + blockTitle);
    clearCampaignScopedData();

    if (!raw) return false;

    try {
        const snapshot: Record<string, string | null> = JSON.parse(raw);
        CAMPAIGN_SCOPED_KEYS.forEach(key => {
            const value = snapshot[key];
            if (value !== null && value !== undefined) {
                localStorage.setItem(key, value);
            }
        });
        return true;
    } catch {
        return false;
    }
};

export const switchActiveCampaignBlock = (previousBlockTitle: string | null | undefined, newBlockTitle: string) => {
    if (previousBlockTitle && previousBlockTitle === newBlockTitle) return;

    if (previousBlockTitle) {
        saveCampaignSnapshotForBlock(previousBlockTitle);
    }
    restoreCampaignSnapshotForBlock(newBlockTitle);
};

/**
 * @param data 
 * @returns 
 */
export const convertFormatData2Text = (data: Array<CheckBoxList>, sep: string = "--") => {
    const result_concat = data.map(item => item.status ? "t" : "f").join(sep);
    return result_concat
}

/**
 * @param data 
 * @returns
 */
export const getOnlyTrueStatus = (data: Array<CheckBoxList>, sep: string = "$$") => {
    const filteredTitles = data.filter(item => item.status).map(item => item.title);
    
    if (filteredTitles.length > 1) {
        return filteredTitles.join(sep);
    } else if (filteredTitles.length === 1) {
        return filteredTitles[0];
    } else {
        return "";
    }
}

export const ordonnerTableau = (tableau: string[], ordre_reel_tableau: string[], keysArray: string[]): string[] => {
    
    const result: string[] = [];

    for (let i = 0; i < ordre_reel_tableau.length; i++) {
        const index = tableau.indexOf(ordre_reel_tableau[i]);
        if (index !== -1) {
            result[i] = keysArray[index];
        }
    }

    return result;
  }

const SECRET_KEY = String(process.env.REACT_APP_ENCRIPT_SECRET_KEY)

export const encryptText = (text: string) => { return CryptoJS.AES.encrypt(text, SECRET_KEY).toString(); }
export const decryptText = (encrypted: string) => { return CryptoJS.AES.decrypt(encrypted, SECRET_KEY).toString(CryptoJS.enc.Utf8) }

/**
 * 
 * @param name
 * @param data
 */
export const encryptData = (name: string, data: any) => {
    const encrypted = encryptText(JSON.stringify(data));
    localStorage.setItem(name, encrypted);
}

/**
 * 
 * @param name
 * @returns
 */
export const decryptData = (name: string) => {
    const raw = localStorage.getItem(name);
    if (raw === null) return null;
    
    try {
        return JSON.parse(raw);
    } catch {
        try {
            const decrypted = decryptText(raw);
            return decrypted === "" ? null : JSON.parse(decrypted);
        } catch {
            return null;
        }
    }
}

/**
 * @param {Object} body_
 * @returns {Array<Object>}
 */
export function prepareCampaignData(body_: any) {
  const preparedEntries = [];

  const mails = body_?.data || [];
  const campaignInfo = mails[0]?.data?.campaign || {};

  for (const mailEntry of mails) {
    const mailData = mailEntry.data || {};
    const mailContext = mailData.mail_context || {};

    const contextClassification = {
      category: mailContext["catégorie"] || "",
      sub_category: mailContext.post_classification?.classe || "",
      theme: mailContext.post_classification?.sous_classe || "",
    };

    const mailContextClassification = {
      category: mailContext["catégorie"] || "",
      sub_category: mailContext.post_classification?.classe || "",
      theme: mailContext.post_classification?.sous_classe || "",
    };

    const contextData = {
      company: mailData.target_person_company_name || "",
      company_domain_activity: "",
      mail_context: mailContext["résumé"] || "",
      name: mailData.target_person_name || "",
      person_job: mailData.target_person_job || "",
    };

    preparedEntries.push({
      context: mailContext["résumé"] || "",
      context_classification: contextClassification,
      mail_context: mailContext["résumé"] || "",
      mail_context_classification: mailContextClassification,
    
      user_target_name: mailData.target_person_name || "",

      context_data: contextData,

      campaign_name: campaignInfo.campaign_name || "",
      campaign_number: campaignInfo.campaign_number || 0,
      mail_id: mailData.mail_id || "",
    });
  }

  return preparedEntries;
}

export const deleteCampaignSnapshotForBlock = (blockTitle: string) => {
    localStorage.removeItem(CAMPAIGN_SNAPSHOT_PREFIX + blockTitle);
};

/**
 * @param name
 */
export const deleteData = (name: string) => {
    localStorage.removeItem(name);
}